const terrains = {
        // view structure
        title: String("Fincas"),
        terrainsTableTitle: String("Gestió de les meves fincas"),

        // Table headers
        terrainName: String("Nom de la finca"),
        terrainAddressMunicipality: String("Municipi"),
        terrainHomogeneousGrowingArea: String("Zona homogénea de cultiu"),
        terrainCoordinates: String("Coordernades"),
        terrainPlotActionHeader: String("Accions"),

        // Buttons
        terrainNewTerrainButton: String("Crear nova finca"),
        terrainPlotActionModify: String("Editar"),
        terrainPlotActionDelete: String("Eliminar"),
        deletePromptModalTitle: String("Eliminar finca"),
        deleteModalBody: String("Estas apunt d'eliminar una finca. Un cop eliminada serà impossible restablir-la. Estas segur que la vols eliminar?"),
        deleteModalAccept: String("Eliminar"),
        deleteModalRejec: String("Cancel·lar"),
};

export default terrains;